
export const POS_STORAGE_PROGRESS = 'POS_STORAGE_PROGRESS';
export const POS_STORAGE = 'POS_STORAGE';
export const POS_STORAGE_EMPTY = 'POS_STORAGE_EMPTY';

export const posStorageProgressAction = data => ({
	type: POS_STORAGE_PROGRESS,
	data,
});

export const posStorageAction = data => ({
	type: POS_STORAGE,
	data,
});


export const posStorageActionEmpty = () => ({
	type: POS_STORAGE_EMPTY,
	data: {pos: false},
});

